import { get } from 'lodash';

export const getEventTitle = (event) => {
  if (event.exception) {
    return get(event.exception, 'values[0].value', '');
  }
  return event.message || '';
};
